import React from 'react'
import BlogContent from './BlogContent';
import RelatedPosts from './RelatedPosts';

function MainContent() {
   return (
      <div className='flex flex-col pt-8 md:pt-12 lg:pt-[50px] pb-12 md:pb-20 lg:pb-[120px]'>
         <div className='w-full flex flex-col items-center text-center sm:px-6 lg:px-[90px]'>
            <div className="text-xs sm:text-sm text-purple-1 dark:text-purple-300 uppercase mb-2">EDUCATION</div>
            <h1 className="text-2xl sm:text-3xl lg:text-[40px] font-semibold leading-snug md:leading-normal mb-4 text-dark-1 dark:text-white">
               <span className='w-full flex items-center justify-center'>Getting Started The Web</span>
               Development JavaScript in 2022
            </h1>
            <span className='font-sans text-gray-600 dark:text-gray-400 text-sm'>
               August 10, 2022
            </span>
         </div>

         <div className='w-full mt-8 sm:mt-12 lg:mt-24 sm:px-6 lg:px-[90px]'>
            <div className="relative w-full aspect-video rounded-lg overflow-hidden">
               <img
                  src="/blog/blog-single/images.png"
                  alt="Web Development"
                  className="absolute inset-0 w-full h-full object-cover"
                  onError={(e) => {
                     e.target.src = '/fallback-image.png';
                  }}
               />
            </div>
         </div>
         <BlogContent />
         <RelatedPosts />
      </div>
   )
}

export default MainContent